// const axios = require('axios');
// const {
//   OPEN_DATA_API_URL,
//   OPEN_DATA_FIELDS,
//   OPEN_DATA_DATASETS,
//   sorter,
//   cleanUpSchoolObject
// } = require('../src/common');

const OPEN_DATA_LIMIT = 10; // limit on the number of records per data source


// /**
//  * @param {string} name 
//  * @param {{
//  *  state: (string|undefined),
//  *  city: (string|undefined)
//  * }} filters 
//  * @return {Promise<{
//  *  results: Array<Object>,
//  *  total_count: number
//  * }>}
//  */
// async function fetchUSSchools(name, filters = {}) {
//   let total_count = 0;
//   name = name.replace(/"/g, '');
//   const results = (await Promise.all(OPEN_DATA_DATASETS.map(async (dataset) => {
//     const search = new URLSearchParams({
//       limit: OPEN_DATA_LIMIT,
//       select: OPEN_DATA_FIELDS
//     });
//     let where = name ? `search(name,"${name}")` : '';
//     if (name && dataset.has_alias)
//       where = `(${where} OR search(alias,"${name}"))`;
//     if (filters.state)
//       where += ` AND state="${filters.state}"`;
//     if (filters.city)
//       where += ` AND city LIKE "${filters.city}"`;
//     if (where.startsWith(' AND '))
//       where = where.slice(5);
//     search.set('where', where);
//     let data = {
//       results: [],
//       total_count: 0
//     };
//     try {
//       const response = await axios.get(`${OPEN_DATA_API_URL}${dataset.db_name}/records?${search.toString()}`);
//       data = response.data;
//     } catch (err) {
//       console.warn(err);
//     }
//     total_count += data.total_count;
//     data.results.forEach(school => cleanUpSchoolObject(school, dataset.db_name));
//     return data.results;
//   }))).flat();
//   results.sort(sorter(school => school.name));
//   return {
//     results,
//     total_count
//   };
// }

const searchCache = {};
async function createSearch(country, state, city) {
  const key = `${state}-${city}`;
  if (searchCache[key])
    return searchCache[key];
  const { default: Fuse } = await import('fuse.js');
  let schools = [];
  if (country == 'CA')
    schools = (await import('ca-schools')).list;
  else {
    switch (state) {
      case 'AL':
        schools = (await import('us-al-schools')).list;
        break;
      case 'AK':
        schools = (await import('us-ak-schools')).list;
        break;
      case 'AS':
        schools = (await import('us-as-schools')).list;
        break;
      case 'AZ':
        schools = (await import('us-az-schools')).list;
        break;
      case 'CA':
        schools = (await import('us-ca-schools')).list;
        break;
      case 'CO':
        schools = (await import('us-co-schools')).list;
        break;
      case 'CT':
        schools = (await import('us-ct-schools')).list;
        break;
      case 'DE':
        schools = (await import('us-de-schools')).list;
        break;
      case 'DC':
        schools = (await import('us-dc-schools')).list;
        break;
      case 'FL':
        schools = (await import('us-fl-schools')).list;
        break;
      case 'GA':
        schools = (await import('us-ga-schools')).list;
        break;
      case 'GU':
        schools = (await import('us-gu-schools')).list;
        break;
      case 'HI':
        schools = (await import('us-hi-schools')).list;
        break;
      case 'ID':
        schools = (await import('us-id-schools')).list;
        break;
      case 'IL':
        schools = (await import('us-il-schools')).list;
        break;
      case 'IN':
        schools = (await import('us-in-schools')).list;
        break;
      case 'IA':
        schools = (await import('us-ia-schools')).list;
        break;
      case 'KS':
        schools = (await import('us-ks-schools')).list;
        break;
      case 'KY':
        schools = (await import('us-ky-schools')).list;
        break;
      case 'LA':
        schools = (await import('us-la-schools')).list;
        break;
      case 'ME':
        schools = (await import('us-me-schools')).list;
        break;
      case 'MD':
        schools = (await import('us-md-schools')).list;
        break;
      case 'MA':
        schools = (await import('us-ma-schools')).list;
        break;
      case 'MI':
        schools = (await import('us-mi-schools')).list;
        break;
      case 'MN':
        schools = (await import('us-mn-schools')).list;
        break;
      case 'MS':
        schools = (await import('us-ms-schools')).list;
        break;
      case 'MO':
        schools = (await import('us-mo-schools')).list;
        break;
      case 'MT':
        schools = (await import('us-mt-schools')).list;
        break;
      case 'NE':
        schools = (await import('us-ne-schools')).list;
        break;
      case 'NV':
        schools = (await import('us-nv-schools')).list;
        break;
      case 'NH':
        schools = (await import('us-nh-schools')).list;
        break;
      case 'NJ':
        schools = (await import('us-nj-schools')).list;
        break;
      case 'NM':
        schools = (await import('us-nm-schools')).list;
        break;
      case 'NY':
        schools = (await import('us-ny-schools')).list;
        break;
      case 'NC':
        schools = (await import('us-nc-schools')).list;
        break;
      case 'ND':
        schools = (await import('us-nd-schools')).list;
        break;
      case 'MP':
        schools = (await import('us-mp-schools')).list;
        break;
      case 'OH':
        schools = (await import('us-oh-schools')).list;
        break;
      case 'OK':
        schools = (await import('us-ok-schools')).list;
        break;
      case 'OR':
        schools = (await import('us-or-schools')).list;
        break;
      case 'PA':
        schools = (await import('us-pa-schools')).list;
        break;
      case 'PR':
        schools = (await import('us-pr-schools')).list;
        break;
      case 'RI':
        schools = (await import('us-ri-schools')).list;
        break;
      case 'SC':
        schools = (await import('us-sc-schools')).list;
        break;
      case 'SD':
        schools = (await import('us-sd-schools')).list;
        break;
      case 'TN':
        schools = (await import('us-tn-schools')).list;
        break;
      case 'TX':
        schools = (await import('us-tx-schools')).list;
        break;
      case 'UT':
        schools = (await import('us-ut-schools')).list;
        break;
      case 'VT':
        schools = (await import('us-vt-schools')).list;
        break;
      case 'VI':
        schools = (await import('us-vi-schools')).list;
        break;
      case 'VA':
        schools = (await import('us-va-schools')).list;
        break;
      case 'WA':
        schools = (await import('us-wa-schools')).list;
        break;
      case 'WV':
        schools = (await import('us-wv-schools')).list;
        break;
      case 'WI':
        schools = (await import('us-wi-schools')).list;
        break;
      case 'WY':
        schools = (await import('us-wy-schools')).list;
        break;
    }
  }
  const results = schools.filter(school => {
    if (state && school.state != state)
      return false;
    if (city && school.city != city)
      return false;
    return true;
  });
  searchCache[key] = new Fuse(results, {
    includeScore: true,
    ignoreLocation: true,
    keys: ['name', 'alias']
  });
  searchCache[key].list = results;
  return searchCache[key];
}

/**
 * @param {string} name 
 * @param {{
 *  state: (string|undefined),
 *  city: (string|undefined)
 * }} filters 
 * @return {Promise<{
 *  results: Array<Object>,
 *  total_count: number
 * }>}
 */
async function fetchUSSchools(name, filters = {}) {
  const fuse = await createSearch('US', filters.state, filters.city);
  // if name = '', fuse would return empty list, so we would be reporting there are no matches, returning info about the full list in this case
  const results = name ?
    fuse.search(name).filter(record => record.score <= 0.5) :
    fuse.list;
  const selected_results = results
    .map(record => record.item || record)
    .slice(0, OPEN_DATA_LIMIT);
  return {
    results: selected_results,
    total_count: results.length
  };
}

/**
 * @param {string} name 
 * @param {{
 *  state: (string|undefined),
 *  city: (string|undefined)
 * }} filters 
 * @return {Promise<{
 *  results: Array<Object>,
 *  total_count: number
 * }>}
 */
async function fetchCASchools(name, filters = {}) {
  const fuse = await createSearch('CA', filters.state, filters.city);
  // if name = '', fuse would return empty list, so we would be reporting there are no matches, returning info about the full list in this case
  const results = name ?
    fuse.search(name).filter(record => record.score <= 0.5) :
    fuse.list;
  const selected_results = results
    .map(record => record.item || record)
    .slice(0, OPEN_DATA_LIMIT);
  selected_results.forEach(school => school.source = 'ca-schools');
  return {
    results: selected_results,
    total_count: results.length
  };
}

module.exports = {
  fetchCASchools,
  fetchUSSchools
};